import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const PublisherIndex = () => {
  const router = useRouter();
  const slug = (router.query.slug as string[]) || [];
  const { data: session } = useSession();

  // Append Org Id and redirect.
  useEffect(() => {
    if (!router.query.publisherId && slug.length && session) {
      const publisherPermissions =
        session?.user?.bamx_perms?.publishers &&
        Object.keys(session?.user?.bamx_perms?.publishers);

      if (publisherPermissions) {
        const path = router.asPath.split('/publisher');
        router.replace(`/publisher/${publisherPermissions[0]}${path[1]}`);
      }
    }
  }, [session]);
  return <></>;
};

export default PublisherIndex;
